import type { TMessages } from '@/types/TMessages'

export const messages = {
  bannerHeader: 'Подписывайтесь на наш Telegram канал!',
  bannerText: 'Важные агроновости, цены на урожай и советы агрономов бесплатно.',
} satisfies TMessages
